import { VivoPlotProps } from "@/components/VivoPlots/types";

export const updatePlot = (
  plots: VivoPlotProps[],
  plotId: string,
  updates: Partial<VivoPlotProps["config"]>,
) =>
  plots.map((plot) =>
    plot.config.plotId === plotId
      ? { ...plot, config: { ...plot.config, ...updates } }
      : plot,
  );

export const setAllHidden = (plots: VivoPlotProps[], hidden: boolean) =>
  plots.map((plot) => ({
    ...plot,
    config: { ...plot.config, hidden },
  }));
